// removed by extract-text-webpack-plugin
module.exports = {"title":"_1dN_D","single":"_1ipgj","medium":"_1qN9A","search":"sAGvv","large":"_1Iw0w","membersArea":"_3npnP"};


//////////////////
// WEBPACK FOOTER
// ./app/components/post-title/post-title.scss
// module id = 1073
// module chunks = 0 3 4 6